import React from 'react';

import classNames from 'classnames';

import {
  CANDIDATE_STATUS_CLASSES,
  CANDIDATE_STATUS_LABEL,
  EDITION_STATUS_CLASSES,
  EDITION_STATUS_LABEL,
} from '../constants';
import { CandidateApprovalStatus, EditionStatus } from '../types';

export const EditionStatusBadge: React.FC<{ status: EditionStatus }> = ({ status }) => (
  <span
    className={classNames(
      'inline-block px-2 py-0.5 text-xs font-medium rounded',
      EDITION_STATUS_CLASSES[status]
    )}
  >
    {EDITION_STATUS_LABEL[status]}
  </span>
);

export const CandidateStatusBadge: React.FC<{ status: CandidateApprovalStatus }> = ({ status }) => (
  <span
    className={classNames(
      'inline-block px-2 py-0.5 text-xs font-medium rounded',
      CANDIDATE_STATUS_CLASSES[status]
    )}
  >
    {CANDIDATE_STATUS_LABEL[status]}
  </span>
);
